import {Node} from 'tiptap'

export default class Url extends Node {
  get name() {
    return 'url'
  }

  get schema() {
    return {
      inline: true,
      attrs: {
        href: {},
        text: {},
        target: {
          default: '_blank',
        },
        title: {
          default: null,
        },
        class: {
          default: null,
        },
      },
      group: 'inline',
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom) => ({
            href: dom.getAttribute('href'),
          }),
        },
      ],
      toDOM: (node) => ['a', node.attrs, `${node.attrs.text}`],
    }
  }

  commands({type}) {
    return (attrs) => (state, dispatch) => {
      const {selection, tr} = state
      const {empty, $from, $to, $cursor} = selection
      const position = $cursor ? $cursor.pos : $from.pos
      const content = selection.content().content
      let transaction = tr

      // ensures no fancy stuff is selected
      if (!empty && $from.sameParent($to) && $from.parent.inlineContent) {
        const contentNode = content.content[0]
        const text = contentNode.textContent
        transaction.insertText('', $from.pos, $from.pos + text.length)
      }

      const node = type.create(attrs)
      transaction.insert(position, node)
      dispatch(transaction)
    }
  }
}
